import { GA3ParameterExclusions } from "@features/google-analytics/ga3-parameter-exclusions";
import { GA4ParameterExclusions } from "@features/google-analytics/ga4-parameter-exclusions";

export const GoogleAnalyticsParameterExclusions = () => (
  <div className="bg-white px-7 p-5 rounded-md flex flex-col gap-3 border container-xl">
    <div className="flex flex-col gap-3">
      <h1 className="heading mx-0 mb-0 mt-0">
        Google Analytics Parameter Exclusions
      </h1>
      <hr className="mb-0 mt-0" />
    </div>
    <div className="flex flex-col grow relative gap-6">
      <GA3ParameterExclusions />
      <GA4ParameterExclusions />
    </div>
  </div>
);
